export const CHART_TYPES = {
  line: 'line',
};

export const CHART_DATA_KEYS = {
  income: 'income',
  expenses: 'expenses',
};
